// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zjwt","footer":"styles_footer__2vSwU","passCodeTooltip":"styles_passCodeTooltip__2RUrZ"};